// extracted by mini-css-extract-plugin
module.exports = {"skuBullets":"s7yHUL3nfqLcYBUyVTfnTQ=="};